import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setError('');
            setSuccess('');
            setLoading(true);

            await sendPasswordResetEmail(auth, email);

            setSuccess('נשלח אימייל לאיפוס סיסמה! בדוק את תיבת הדואר שלך.');
            setEmail('');
        } catch (err) {
            console.error('Password reset error:', err);

            if (err.code === 'auth/user-not-found') {
                setError('לא נמצא משתמש עם כתובת אימייל זו');
            } else if (err.code === 'auth/invalid-email') {
                setError('כתובת אימייל לא תקינה');
            } else if (err.code === 'auth/too-many-requests') {
                setError('יותר מדי בקשות. נסה שוב מאוחר יותר');
            } else {
                setError('שגיאה בשליחת אימייל: ' + err.message);
            }
        }

        setLoading(false);
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>🔑 שחזור סיסמה</h2>

                <p style={styles.description}>
                    הזן את כתובת האימייל שלך ונשלח לך קישור לאיפוס הסיסמה.
                </p>

                {error && <div style={styles.error}>{error}</div>}
                {success && <div style={styles.success}>{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>אימייל</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="example@email.com"
                            required
                            style={styles.input}
                            onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                            onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                        />
                    </div>

                    <button
                        disabled={loading}
                        type="submit"
                        style={{
                            ...styles.button,
                            opacity: loading ? 0.7 : 1,
                            cursor: loading ? 'not-allowed' : 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(-3px) scale(1.02)';
                                e.target.style.boxShadow = '0 8px 25px rgba(192, 192, 192, 0.6), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #c0c0c0';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(0) scale(1)';
                                e.target.style.boxShadow = '0 6px 20px rgba(192, 192, 192, 0.4), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #c0c0c0';
                            }
                        }}
                    >
                        {loading ? 'שולח...' : 'שלח קישור לאיפוס'}
                    </button>
                </form>

                <div style={styles.footer}>
                    <Link
                        to="/login"
                        style={styles.link}
                        onMouseEnter={(e) => e.target.style.color = '#009010'}
                        onMouseLeave={(e) => e.target.style.color = '#007008'}
                    >← חזרה להתחברות</Link>
                </div>

                <div style={styles.footer}>
                    אין לך חשבון? <Link
                        to="/signup"
                        style={styles.link}
                        onMouseEnter={(e) => e.target.style.color = '#009010'}
                        onMouseLeave={(e) => e.target.style.color = '#007008'}
                    >הירשם</Link>
                </div>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #000000 50%, #1a1a1a 100%)',
        direction: 'rtl',
        padding: '15px',
    },
    card: {
        backgroundColor: '#ffffff',
        padding: '40px 30px',
        borderRadius: '15px',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.8), inset 0 0 0 8px #ffffff, inset 0 0 0 12px #ffd966',
        width: '100%',
        maxWidth: '450px',
        border: '3px solid #000000',
        background: 'linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%)',
    },
    title: {
        textAlign: 'center',
        marginBottom: '20px',
        color: '#000000',
        fontSize: 'clamp(22px, 5vw, 28px)',
        fontWeight: 'bold',
        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
        letterSpacing: '0.5px',
        lineHeight: '1.3',
    },
    description: {
        textAlign: 'center',
        color: '#333333',
        fontSize: '14px',
        marginBottom: '25px',
        lineHeight: '1.5',
    },
    error: {
        backgroundColor: '#ffe5e5',
        color: '#cc0000',
        padding: '12px',
        borderRadius: '8px',
        marginBottom: '20px',
        textAlign: 'center',
        border: '2px solid #cc0000',
        fontSize: '14px',
    },
    success: {
        backgroundColor: '#e5f7e5',
        color: '#007008',
        padding: '12px',
        borderRadius: '8px',
        marginBottom: '20px',
        textAlign: 'center',
        fontWeight: 'bold',
        border: '2px solid #007008',
    },
    formGroup: {
        marginBottom: '20px',
    },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontWeight: '600',
        color: '#000000',
        fontSize: '15px',
    },
    input: {
        width: '100%',
        padding: '14px 16px',
        border: '2px solid #c0c0c0',
        borderRadius: '8px',
        fontSize: '16px',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff',
        color: '#000000',
        transition: 'all 0.3s ease',
        outline: 'none',
    },
    button: {
        width: '100%',
        padding: '18px',
        background: 'radial-gradient(circle at 30% 30%, #c0c0c0, #909090 40%, #c0c0c0 60%, #909090)',
        color: '#000000',
        border: '4px solid #000000',
        borderRadius: '50px',
        fontSize: '17px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 6px 20px rgba(192, 192, 192, 0.4), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #c0c0c0',
        textTransform: 'uppercase',
        letterSpacing: '1.5px',
    },
    footer: {
        marginTop: '20px',
        textAlign: 'center',
        color: '#333333',
        fontSize: '15px',
    },
    link: {
        color: '#007008',
        textDecoration: 'none',
        fontWeight: 'bold',
        transition: 'color 0.3s ease',
    },
};
